var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserNameIcon = function SvgUserNameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3016_452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 20C17 17.544 15.009 15.553 12.553 15.553H7.447C4.991 15.553 3 17.544 3 20",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12H22",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10L22 12L20 14",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C7.65279 12.5 5.75 10.5972 5.75 8.25C5.75 5.90279 7.65279 4 10 4C12.3472 4 14.25 5.90279 14.25 8.25C14.25 10.5972 12.3472 12.5 10 12.5Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3016_452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
};
export { SvgUserNameIcon as ReactComponent };
export default __webpack_public_path__ + "user-name-icon.svg";